
export const transformCsvAndSetLink = async (sourceUrl, targetColumns = []) => {
  // Helpers: convert Brazilian number string to JS number (international format)
  const convertBrazilianNumber = (str) => {
    if (str == null) return str;
    const s = String(str).trim();
    if (s === "") return s;
    // remove thousands separators (.) and replace decimal comma with dot
    const cleaned = s.replace(/\./g, "").replace(/,/g, ".");
    const num = Number(cleaned);
    return isNaN(num) ? str : num;
  };

  const serializeRow = (fields) => {
    const esc = (field) => {
      if (field == null) return "";
      const s = String(field);
      if (
        s.indexOf(",") >= 0 ||
        s.indexOf('"') >= 0 ||
        s.indexOf("\n") >= 0 ||
        s.indexOf("\r") >= 0
      ) {
        return '"' + s.replace(/"/g, '""') + '"';
      }
      return s;
    };
    return fields.map(esc).join(",");
  };

  const readRowFromText = (text, pos) => {
    const fields = [];
    let cur = "";
    let inQuotes = false;
    let i = pos;
    for (; i < text.length; i++) {
      const ch = text[i];
      const next = text[i + 1];
      if (ch === '"') {
        if (inQuotes && next === '"') {
          cur += '"';
          i++; // skip escaped quote
          continue;
        }
        inQuotes = !inQuotes;
        continue;
      }
      if (ch === "," && !inQuotes) {
        fields.push(cur);
        cur = "";
        continue;
      }
      if ((ch === "\n" || (ch === "\r" && text[i + 1] === "\n")) && !inQuotes) {
        if (ch === "\r") i++; // skip LF
        fields.push(cur);
        return { fields, nextIndex: i + 1 };
      }
      cur += ch;
    }
    // EOF
    fields.push(cur);
    return { fields, nextIndex: text.length };
  };

  try {
    const res = await fetch(sourceUrl);
    const text = await res.text();
    let pos = 0;
    const headerResult = readRowFromText(text, pos);
    const header = headerResult.fields;
    pos = headerResult.nextIndex;

    const targets = Array.isArray(targetColumns) ? targetColumns : [];
    const idxs = targets.map((t) => header.indexOf(t));

    if (idxs.every((i) => i === -1)) {
      return sourceUrl;
    }

    let out = serializeRow(header) + "\n";

    while (pos < text.length) {
      const rowResult = readRowFromText(text, pos);
      pos = rowResult.nextIndex;
      const fields = rowResult.fields;
      while (fields.length < header.length) fields.push("");
      for (let j = 0; j < idxs.length; j++) {
        const idx = idxs[j];
        if (idx !== -1 && idx < fields.length) {
          const orig = fields[idx];
          const cleaned = String(orig).replace(/^\s*"|"\s*$/g, "");
          const converted = convertBrazilianNumber(cleaned);
          fields[idx] = converted;
        }
      }
      out += serializeRow(fields) + (pos < text.length ? "\n" : "");
    }

    const blob = new Blob([out], { type: "text/csv;charset=utf-8;" });
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  } catch (err) {
    console.error("CSV transform failed", err);
    return sourceUrl;
  }
};
